import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import Tabs from "../../common/tabs";
import BankExportViewModel from "../../../viewModels/finance/bankExports/bankExportViewModel";

const BankExportView: ViewComponent<BankExportViewModel> = observer(({ vm }) => (
  <>
    <h3 className="mb-4">{vm.name}</h3>
    <Tabs vm={vm} />
  </>
));

registerView(BankExportView, BankExportViewModel);
